import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

const useOutOfStockFilter = (): boolean => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const featureEnabled = useEnabledFeature('cat-out-of-stock-filter');
  const outOfStockFilterSegmentEnabled = useEnabledSegment(`${abbrBrand}159`);
  return featureEnabled && outOfStockFilterSegmentEnabled;
};

export default useOutOfStockFilter;
